import { Link } from 'react-router-dom';
import SimulatorPreview from '../components/SimulatorPreview';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>Visualize Defensive Strategies in Real Time</h1>
          <p className="hero-subtitle">
            Simulate coverages with endless scenarios.
          </p>
          <Link to="/simulator" className="cta-button">
            Launch Simulator
          </Link>
        </div>
        <div className="hero-visual">
          <SimulatorPreview />
        </div>
      </section>

      <section className="features">
        <h2>What You Can Do</h2>
        <div className="features-grid">
          <article className="feature-card">
            <div className="feature-icon">🏈</div>
            <h3>Fully Customizable Offensive Plays</h3>
            <p>Set a route for every receiver and the back, then watch the coverage respond.</p>
          </article>
          <article className="feature-card">
            <div className="feature-icon">🛡️</div>
            <h3>Coverage Schemes</h3>
            <p>Explore multiple zone, man, and match coverages and see how defenders react.</p>
          </article>
          <article className="feature-card">
            <div className="feature-icon">▶️</div>
            <h3>Real-Time Animation</h3>
            <p>Watch plays unfold with smooth animations showing player movements and reactions.</p>
          </article>
        </div>
      </section>

      <section className="cta-section">
        <h2>Try it!</h2>
        <p>Start simulating defensive coverages in real time!</p>
        <Link to="/simulator" className="cta-button cta-secondary">
          Try the Simulator
        </Link>
      </section>
    </div>
  );
}

export default HomePage;
